import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { AccountingModelDetailModel } from 'src/app/models/management/accounting-model-detail.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountingModelDetailService {

  private readonly _httpClient = inject(HttpClient);

  createAccountingModelDetail(accountingModelDetailContract: AccountingModelDetailModel): Observable<AccountingModelDetailModel> {
    return this._httpClient.post<AccountingModelDetailModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.accountingModelDetail.CreateAccountingModelDetail}`,
      accountingModelDetailContract
    );
  }

  deleteSomeDetails(accountingModelDetailIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.accountingModelDetail.DeleteSomeDetails}`,
      accountingModelDetailIds
    );
  }

  getAccountingModelDetailById(accountingModelDetailId: number): Observable<AccountingModelDetailModel> {
    return this._httpClient.get<AccountingModelDetailModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.accountingModelDetail.GetAccountingModelDetailById}/${accountingModelDetailId}`
    );
  }

  getAccountingModelDetailsForCaptureTable(
    page: number,
    limit: number,
    columnSort: string | null,
    ascendant: boolean,
    accountingModelId: number
  ): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('accountingModelId', accountingModelId);
    return this._httpClient.get<PagedResponseModel<any>>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.accountingModelDetail.GetAccountingModelDetailsForCaptureTableAsync}`,
      { params }
    );
  }

  getColumnsForCaptureTable(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.accountingModelDetail.GetColumnsForCaptureTableAsync}`
    );
  }

  updateAccountingModelDetail(accountingModelDetailContract: AccountingModelDetailModel): Observable<AccountingModelDetailModel> {
    return this._httpClient.put<AccountingModelDetailModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.accountingModelDetail.UpdateAccountingModelDetail}`,
      accountingModelDetailContract
    );
  }

}
